// Naming convention for the printable surface in an uploaded GLB — a real product
// model (pen barrel, mug body, etc.) usually has separate meshes for parts that must
// NOT get the customer's design (clip, cap, tip, metal trim). Shared by the admin's
// calibration editor and the frontend's live 3D preview so both agree on which
// mesh(es) the design texture targets.
export const PRINTABLE_SURFACE_NAME_HINTS = ['body', 'barrel', 'print', 'design', 'surface', 'wrap'];

export function isPrintableSurfaceMeshName(name: string): boolean {
  const lower = name.toLowerCase();
  return PRINTABLE_SURFACE_NAME_HINTS.some(hint => lower.includes(hint));
}
